var mask = {
  date(date) {
    if (date.length == 10) return date;
    if (date.length == 1) {
      if (parseInt(date.substr(0, 1)) > 3) return "0" + date;
    } else if (date.length == 2) {
      if (parseInt(date.substr(0, 2)) > 31 || parseInt(date.substr(0, 2)) == 0)
        return date.substr(0, 1);
    } else if (date.length == 4) {
      if (parseInt(date.substr(3, 1)) > 1)
        return date.substr(0, 3) + "0" + date.substr(3, 1);
    } else if (date.length == 5) {
      if (parseInt(date.substr(3, 2)) > 12 || parseInt(date.substr(3, 2)) == 0)
        return date.substr(0, 4);
    } else if (date.length == 7) {
      if (parseInt(date.substr(6, 1)) > 2 || parseInt(date.substr(6, 1)) < 1)
        return date.substr(0, 6);
    } else if (date.length == 8) {
      if (parseInt(date.substr(6, 2)) > 20 || parseInt(date.substr(6, 2)) < 18)
        return date.substr(0, 7);
    }

    return date;
  },
  dateYearOnly(year) {
    if (year.length == 4) return year;
    if (year.length == 1) {
      if (parseInt(year) > 2 || parseInt(year) < 1) return "";
    } else if (year.length == 2) {
      if (parseInt(year) > 20 || parseInt(year) < 19) return year.substr(0, 1);
    }
    return year;
  },
  emailCheck(email) {
    const re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email != null && email.length > 0) {
      return !re.test(String(email).toLowerCase());
    }
    return false;
  },
  siteCheck(site) {
    if (
      site != null &&
      site.length > 0 &&
      (!/^[a-zA-Z0-9а-яА-Я.-_,;/:]/.test(site) ||
        /[ ]/.test(site) ||
        site.indexOf(".") == -1 ||
        site[0] == "." ||
        site[site.length - 1] == ".")
    ) {
      return true;
    } else return false;
  },
};

export default mask;
